import { init, priceDecorator, thumbnailDecorator } from "@nosto/preact";
import { Serp, Category, Autocomplete, History } from "./components";
import { defaultConfig } from "./config";

import "./styles/index.css";
import { getWizardConfig } from "./wizard";

init({
  ...window.nostoTemplatesConfig,
  serpComponent: Serp,
  historyComponent: History,
  autocompleteComponent: Autocomplete,
  categoryComponent: Category,
  inputCssSelector: ".search-bar input[type='search']",
  contentCssSelector: "#MainContent",
  formCssSelector: ".search-bar form.header-form",
  hitDecorators: [priceDecorator(), thumbnailDecorator({ size: "9" })],
  serpUrlMapping: {
    query: "q",
    "products.filter": "filter",
    "products.page": "page",
    "products.size": "pageSize",
    "products.sort": "sort"
  },
  // Uncomment to redirect to search page instead of rendering on the same page
  serpPath: "/pages/search-results",
  // Uncomment to redirect to search page instead of rewriting browser history
  // serpPathRedirect: true,
  serpQuery: {
    products: {
      facets: ["*"],
      size: defaultConfig.serpSize,
      from: 0
    }
  },
  autocompleteQuery: {
    products: {
      fields: [
        "productId",
        "url",
        "name",
        "imageUrl",
        "thumbUrl",
        "brand",
        "availability",
        "price",
        "priceText",
        "listPrice",
        "onDiscount",
        "priceCurrencyCode",
        "ratingValue",
        "reviewCount"
      ],
      size: defaultConfig.autocompleteProductsSize
    },
    keywords: {
      fields: ["keyword", "_highlight.keyword"],
      size: defaultConfig.autocompleteKeywordsSize,
      facets: ["*"]
    }
  },
  compressUrlParameters: true,
  fallback: true,
  // // Uncomment for Category Merchandising
  //categoryCssSelector: '#fast-simon-serp-app',
  categoryCssSelector: ".nosto-serp-placeholder",
  categoryQuery() {
    return {
      name: "serp",
      products: {
        categoryId: this.categoryId(),
        categoryPath: this.categoryPath(),
        size: defaultConfig.serpSize,
        from: 0
      }
    };
  },

  // Apply configuration wizard last
  ...getWizardConfig()
  // Configuration here will override the changes in the wizard
});
